<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card
        class="page-card overflow-auto"
        style="max-height: calc(100vh - 150px)"
      >
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("shopStockTakePlans.objectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("shopStockTakePlans.objectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 标题 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("shopStockTakePlans.Fields.title")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('shopStockTakePlans.Fields.title')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="shopStockTakePlan.title"
                      single-line
                      dense
                      hide-details
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'title')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ shopStockTakePlan.title }}
                </v-col>
              </v-row>
              <!-- 是否限时 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("shopStockTakePlans.term_flg.title") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-radio-group row v-model="shopStockTakePlan.term_flg">
                    <v-radio
                      :label="$t('shopStockTakePlans.term_flg.term_flg_on')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('shopStockTakePlans.term_flg.term_flg_off')"
                      :key="0"
                      :value="0"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    shopStockTakePlan.term_flg == 1
                      ? $t("shopStockTakePlans.term_flg.term_flg_on")
                      : $t("shopStockTakePlans.term_flg.term_flg_off")
                  }}
                </v-col>
              </v-row>
              <!-- 限时时间 -->
              <v-row align="center" v-if="shopStockTakePlan.term_flg == 1">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("shopStockTakePlans.DetailFieds.term_date") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <SearcherDatetime
                    class="my-n2"
                    v-if="savable"
                    v-model="shopStockTakePlan.term_date"
                    type="dateminutes"
                    single-line
                    dense
                    hide-details
                    hide-icon
                    :disabled-before-today="savable"
                  />
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ shopStockTakePlan.term_date | formatDateMinutes }}
                </v-col>
              </v-row>

              <!-- 发布对象 -->
              <v-row v-if="!savable">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("shopStockTakePlans.DetailFieds.shop", [
                      $consts.shopName(),
                    ])
                  }}{{ $t("Global.colon") }}
                </v-col>
                <v-col cols="9">
                  <v-data-table
                    :headers="headers"
                    :items="shopStockTakePlan.shop_stock_take_plan_details"
                    multi-sort
                    :footer-props="$t('$config.footer-props')"
                    class="elevation-2 px-4 pt-1"
                  >
                    <template v-slot:header.shop.shop_name>
                      {{
                        $t("shopStockTakePlans.DetailFieds.shop_name", [
                          $consts.shopName(),
                        ])
                      }}
                    </template>
                    <template v-slot:header.action="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.is_over="{ item }">
                      {{
                        item.is_over == 1
                          ? $t("shopStockTakePlans.is_over.is_over_true")
                          : item.is_over == 2
                          ? $t("shopStockTakePlans.is_over.is_over_cancel")
                          : $t("shopStockTakePlans.is_over.is_over_false")
                      }}
                    </template>
                    <template v-slot:item.over_time="{ item }">
                      {{ item.over_time | formatTime }}
                    </template>
                    <template v-slot:item.is_push="{ item }">
                      {{
                        item.is_push == 2
                          ? $t("shopStockTakePlans.is_push.is_push_error")
                          : item.is_push == 1
                          ? $t("shopStockTakePlans.is_push.is_push_ok")
                          : $t("shopStockTakePlans.is_push.is_push_no")
                      }}
                    </template>
                    <template v-slot:item.action="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="detailCancel(item.id)"
                        v-if="item.is_over == 0 && item.is_push == 1"
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <!-- 商品 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("shopStockTakePlans.DetailFieds.material_name")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                  <br />
                  <v-btn
                    v-if="savable"
                    color="primary"
                    class="my-1 mr-3"
                    x-small
                    outlined
                    @click="materials_dialog = true"
                  >
                    {{
                      $t("CRUD.chooseInfo", [
                        $t("shopStockTakePlans.DetailFieds.material"),
                      ])
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="9" md="7">
                  <v-data-table
                    :headers="materialHeaders"
                    :items="materials"
                    multi-sort
                    class="elevation-2 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:body.prepend>
                      <tr
                        class="d-none d-sm-table-row"
                        v-if="savable && materials.length"
                      >
                        <td colspan="4"></td>
                        <td v-if="savable">
                          <v-btn
                            small
                            outlined
                            dark
                            color="danger"
                            class="px-2 me-2 mb-1"
                            @click.stop="materials = []"
                          >
                            {{ $t("shopStockTakePlans.DetailFieds.removeAll") }}
                          </v-btn>
                        </td>
                      </tr>
                      <!-- 小屏 -->
                      <tr
                        class="d-table-row d-sm-none"
                        v-if="savable && materials.length"
                      >
                        <td class="v-data-table__mobile-row">
                          <div class="v-data-table__mobile-row__header mt-1">
                            {{ $t("TableHeaders.actions") }}
                          </div>
                          <div class="v-data-table__mobile-row__cell mt-1">
                            <v-btn
                              small
                              outlined
                              dark
                              color="danger"
                              class="px-2 me-2 mb-1"
                              @click.stop="materials = []"
                            >
                              {{
                                $t("shopStockTakePlans.DetailFieds.removeAll")
                              }}
                            </v-btn>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.show_categories="{ item }">
                      <v-tooltip
                        right
                        v-if="
                          item.show_categories &&
                          item.show_categories.length > 0
                        "
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{
                              item.show_categories[0].parent_show_category
                                ? item.show_categories[0].parent_show_category
                                    .name + " : "
                                : ""
                            }}
                            {{ item.show_categories[0].name }}
                            {{ item.show_categories.length > 1 ? "..." : "" }}
                          </span>
                        </template>
                        <span
                          v-for="(show_category, index) in item.show_categories"
                          :key="show_category.id"
                          class="d-inline"
                        >
                          {{
                            show_category.parent_show_category
                              ? show_category.parent_show_category.name + " : "
                              : ""
                          }}
                          {{
                            show_category.name +
                            (index == item.show_categories.length - 1
                              ? ""
                              : ",")
                          }}
                        </span>
                      </v-tooltip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <!-- 删除商品按钮 -->
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          materials.splice(
                            materials.findIndex(
                              (material) => material.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>

      <v-card class="page-opts">
        <v-card-title class="pa-2">
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{
                  $t("CRUD.backToList", [$t("shopStockTakePlans.objectName")])
                }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !shopStockTakePlan.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("shopStockTakePlans.objectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
    <MaterialsSelectsDialog
      v-model="materials_dialog"
      fullField
      showCategories
      :materialIds="materialIds"
      @confirm="choosedMaterials = $event"
    />
  </div>
</template>
<style>
.material-img {
  width: 50% !important;
}
.material-img p {
  margin: 0;
}
.material-img p img {
  width: 100% !important;
  height: 100% !important;
}
</style>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import i18n from "@/i18n";
import ShopStockTakePlans from "@/api/shop_stock_take_plans";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import MaterialsSelectsDialog from "@/components/plugins/MaterialsSelectsDialog";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    ValidationObserver,
    ValidationProvider,
    SearcherDatetime,
    MaterialsSelectsDialog,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    headers() {
      return [
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.shop_name"),
          align: "start",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.is_over"),
          align: "start",
          sortable: false,
          value: "is_over",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.over_time"),
          align: "start",
          sortable: false,
          value: "over_time",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.is_push"),
          align: "start",
          sortable: false,
          value: "is_push",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.push_msg"),
          align: "start",
          sortable: false,
          value: "push_msg",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ];
    },
    materialHeaders() {
      var headers = [
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.category_name"),
          align: "start",
          sortable: false,
          value: "material_category.name",
        },
        {
          text: i18n.t("shopStockTakePlans.DetailFieds.show_categories"),
          align: "start",
          sortable: false,
          value: "show_categories",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("shopStockTakePlans.DetailFieds.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    serverErrors: [],
    shopStockTakePlan: {
      title: "",
      term_flg: 0,
      term_date: null,
    },
    materials: [],
    materials_dialog: false,
    materialIds: [],
    choosedMaterials: [],
  }),

  methods: {
    save() {
      this.serverErrors = []; //重置远端错误提示
      var data = {};
      data = {
        title: this.shopStockTakePlan.title,
        term_flg: this.shopStockTakePlan.term_flg,
        term_date: this.shopStockTakePlan.term_flg
          ? this.shopStockTakePlan.term_date + ":00"
          : this.shopStockTakePlan.term_date,
        material_ids: this.materials.length
          ? this.materials.map((material) => material.id)
          : [],
      };
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            if (!this.materials.length) {
              this.$snackbar.error(
                i18n.t("shopStockTakePlans.DetailFieds.materialsNull")
              );
            } else {
              if (this.isNew) {
                ShopStockTakePlans.add(data).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      var shop_stock_take_plan_data = JSON.parse(
                        JSON.stringify(response.data.shop_stock_take_plan)
                      );
                      this.$emit("save", this.shop_stock_take_plan_data);
                      this.$emit("mode", null);
                      this.$emit("input", null);
                      window.open(
                        "/#/stock-take-orders/detail/stock-take-plans/shop-stock-take-plans/push-to-shop/" +
                          shop_stock_take_plan_data.id,
                        "_self"
                      );
                    } else if (
                      response.data.error &&
                      response.data.error.data &&
                      "ERR333" == response.data.error.code
                    ) {
                      this.serverErrors = response.data.error.data;
                    }
                  }.bind(this)
                );
              } else if (this.mode == "edit") {
                ShopStockTakePlans.editPlan(
                  Object.assign({}, data, { id: this.value.id })
                ).then(
                  function (response) {
                    if (response.data.status.isOK()) {
                      this.$emit("save", this.shop_stock_take_plan_data);
                      this.$emit("mode", null);
                      this.$emit("input", null);
                    } else if (
                      response.data.error &&
                      response.data.error.data &&
                      "ERR333" == response.data.error.code
                    ) {
                      this.serverErrors = response.data.error.data;
                    }
                  }.bind(this)
                );
              }
            }
          }
        }.bind(this)
      );
    },
    detailCancel(id) {
      ShopStockTakePlans.detailCancel(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getShopStockTakePlanFromAPI();
          }
        }.bind(this)
      );
    },
    getShopStockTakePlanFromAPI() {
      ShopStockTakePlans.fetchOne(this.value.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopStockTakePlan = response.data.shop_stock_take_plan;
            this.materials =
              response.data.shop_stock_take_plan.material_details;
            this.shopStockTakePlan.term_date = this.shopStockTakePlan.term_date
              ? this.$datetimeUtils.formatDateMinutes(
                  this.shopStockTakePlan.term_date
                )
              : null;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        this.shopStockTakePlan = {
          title: "",
          term_flg: 0,
          term_date: null,
        };
        this.materials = [];
        if (this.value && this.value.id) {
          this.getShopStockTakePlanFromAPI();
        }
        this.$scrollTop(); //返回顶部
      },
    },
    materials: {
      deep: true,
      handler() {
        if (this.materials.length) {
          this.materialIds = this.materials.map((material) => {
            return material.id;
          });
        } else {
          this.materialIds = [];
        }
      },
    },
    choosedMaterials: {
      handler() {
        //  综合多次选择的商品
        this.choosedMaterials.forEach((material) => {
          this.materials.push(Object.assign({}, material));
        });
      },
    },
  },
};
</script>

<style>
</style>